import React, { useState, useEffect } from "react";
import { store } from "app/store";
import { API_URL } from "app/config";
import {
  Typography,
  Tooltip,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Modal } from "antd";
import { Modal as ModalBoot } from "react-bootstrap";
import { BuyerListMandi } from "./BuyerListMandi";
import { FarmerAdminNegotiation } from "./FarmerAdminNegotiation";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import { Card, CardBody, Row, Col } from "reactstrap";
import CustomSearchBar from "components/CustomSearchBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRotateLeft,
  faPenToSquare,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Button as BootstrapButton } from "react-bootstrap";
import * as XLSX from "xlsx";
import { DataGrid } from "@mui/x-data-grid";
import { EditMandiDetails } from "./EditMandiDetails";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
export const Mandi = ({ isHCL }) => {
  const { id } = useParams();
  const orgId = id ? id : "";
  const [trades, setTrades] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tradeData, setTradeData] = useState([]);
  const [tradeDataFiltered, setTradeDataFiltered] = useState([]);
  // const [pagination, setPagination] = useState({ page: 1, pageCount: 10 });
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const [editDetails, setEditDetails] = useState("");
  const [negotiateModal, setnegotiateModal] = useState(false);
  const [activeNegotiation, setactiveNegotiation] = useState("ByFarmer");
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [selectedProduct, setSelectedLabel] = useState("");
  const [editDetailsModal, setEditModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    handleApi();
  }, [isHCL]);

  const handleApi = () => {
    const state = store.getState();
    fetch(
      `${API_URL}/api/v1/onboarding/farmer-aggrigation?organization_id=${orgId}`,
      {
        headers: { authorization: `Bearer ${state.auth.accessToken}` },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data != undefined) {
          setTrades(data?.data);

          setTradeDataFiltered(data?.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleEditDetails = (details) => {
    setEditDetails(details);
    setEditModal(true);
  };

  const handleLocation = (location, val) => {
    const value = location
      ? location.split(",").map((item) => item.trim())
      : [];
    if (value.length < 3) return "-";
    const lastElement = value[value.length - 2];
    const hasPincode = !isNaN(lastElement.trim());
    const stateIndex = hasPincode ? value.length - 3 : value.length - 2;
    const districtIndex = hasPincode ? value.length - 4 : value.length - 3;
    const blockIndex = hasPincode ? value.length - 5 : value.length - 4;
    const state = value[stateIndex] || "-";
    const district = value[districtIndex] || "-";
    const block = value[blockIndex] || "-";
    if (val === "state") return state;
    if (val === "district") return district;
    if (val === "block" && (block === "Phulpur" || block === "Soraon"))
      return "Bahariya";
    if (val === "block" && block !== "Phulpur") return block;
    return "-";
  };

  const columns = [
    {
      field: "Commodity",
      headerName: "Commodity",
      flex: 1,
      minWidth: 220,
      sortable: true,
      valueGetter: (value) => `${value.row?.commodity?.name}`,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          <img
            src={params.row.commodity.image_url}
            alt="img"
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "50%",
              border: "1px solid #ddd",
              boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
              marginRight: "8px",
              marginTop: "2px",
            }}
          />
          <span
          // style={{ maxWidth: "150px", wordBreak: "break-word" }}
          >
            &nbsp;&nbsp;{params.row.commodity.name}
          </span>
        </div>
      ),
    },

    {
      field: "name",
      headerName: "Farmer Name",
      sortable: true,
      width: 190,
      valueGetter: (value) => `${value.row?.seller?.name}`,
      renderCell: (params) => <div>{params.row.seller.name}</div>,
    },
    {
      field: "mobile",
      headerName: "Phone No",
      width: 100,
      sortable: true,
      valueGetter: (value) => `${value.row?.seller?.phone_number}`,
      renderCell: (params) => <div>{params.row.seller.phone_number}</div>,
    },

    {
      field: "state",
      headerName: "State",
      width: 130,
      sortable: true,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ marginLeft: "8px" }}>
          {handleLocation(params.row.seller.farm_location, "state")}
        </Typography>
      ),
    },
    {
      field: "district",
      headerName: "District",
      width: 130,
      sortable: true,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ marginLeft: "8px" }}>
          {handleLocation(params.row.seller.farm_location, "district")}
        </Typography>
      ),
    },
    {
      field: "block",
      headerName: "Block",
      width: 130,
      sortable: true,
      valueGetter: (params) => {
        handleLocation(params.row.seller.farm_location, "block");
      },
      renderCell: (params) => (
        <Typography variant="body2" sx={{ marginLeft: "8px" }}>
          {handleLocation(params.row.seller.farm_location, "block")}
        </Typography>
      ),
    },
    {
      field: "variety",
      headerName: "Variety",
      width: 120,
      sortable: true,
      valueGetter: (value) => `${value.row?.commodity?.variety}`,
      renderCell: (params) => (
        <Tooltip title={params.row.commodity.variety}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginLeft: "8px" }}
          >
            {params.row.commodity.variety}
          </Typography>
        </Tooltip>
      ),
    },

    {
      field: "quantity",
      headerName: "Quantity",
      width: 130,
      sortable: true,
      valueGetter: (value) =>
        `${value.row?.quantity} ${value.row.unit_of_quantity}`,
      renderCell: (params) => (
        <Typography
          variant="body2"
          color="text.primary"
          sx={{ marginLeft: "8px" }}
        >
          {`${params.row.quantity} ${params.row.unit_of_quantity}`}
        </Typography>
      ),
    },
    {
      field: "quoted_price",
      headerName: "Rate",
      width: 100,
      sortable: true,
      valueGetter: (value) => `${value.row?.quoted_price}`,
      renderCell: (params) => (
        <Typography
          variant="body2"
          color="success.main"
          fontWeight="bold"
          sx={{ marginLeft: "8px" }}
        >
          ₹{params.row.quoted_price}
        </Typography>
      ),
    },
    {
      field: "current_status",
      headerName: "Status",
      width: 140,
      sortable: true,
      valueGetter: (params) => params.row.current_status,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color:
              params.row.current_status === "Procurement Done"
                ? "success.main"
                : params.row.current_status === "Negotiation Done"
                ? "warning.main"
                : "primary.main",
            marginLeft: "8px",
          }}
        >
          {params.row.current_status}
        </Typography>
      ),
    },

    RoleAcessParams.includes("FPO")
      ? ""
      : {
          field: "assignBuyer",
          headerName: "Actions",
          width: 250,
          renderCell: (params) => (
            <>
              <Button
                variant="contained"
                size="small"
                sx={{
                  textTransform: "none",
                  fontWeight: "medium",
                  boxShadow: "none",
                  backgroundColor: "#FFA500",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#FF8C00",
                    boxShadow: "0px 4px 12px rgba(255, 140, 0, 0.3)",
                  },
                  borderRadius: "6px",
                  padding: "4px 8px",
                  minWidth: "90px",
                  marginLeft: "8px",
                }}
                endIcon={<ArrowForward fontSize="small" />}
                onClick={() => {
                  setModalOpen(true);
                  setTradeData(params.row);
                }}
              >
                Assign Buyer
              </Button>

              <Button
                variant="outlined"
                size="small"
                sx={{
                  textTransform: "none",
                  fontWeight: "medium",
                  color: "#FF8C00",
                  borderColor: "#FF8C00",
                  "&:hover": {
                    backgroundColor: "rgba(255, 140, 0, 0.1)",
                    borderColor: "#FF7F11",
                    boxShadow: "0px 4px 12px rgba(255, 140, 0, 0.3)",
                  },
                  borderRadius: "6px",
                  padding: "4px 8px",
                  minWidth: "90px",
                  marginLeft: "8px",
                }}
                endIcon={<ArrowForward fontSize="small" />}
                onClick={() => {
                  setnegotiateModal(true);
                  setTradeData(params.row);
                }}
              >
                Negotiate
              </Button>
            </>
          ),
        },

    {
      field: "action",
      headerName:
        RoleAcessParams.includes("HCL") || RoleAcessParams.includes("UP_GOV")
          ? "Action"
          : "",
      width: 80,
      renderCell: (cellvalues) => {
        return (
          <>
            <FontAwesomeIcon
              icon={
                RoleAcessParams.includes("HCL") ||
                RoleAcessParams.includes("UP_GOV")
                  ? faEye
                  : faPenToSquare
              }
              className="mx-2"
              style={{ color: "orange", fontSize: "16px", cursor: "pointer" }}
              // onClick={() => {
              //   RoleAcessParams.includes("HCL")|| RoleAcessParams.includes("UP_GOV")
              //     ? navigate(`/farmerDetail/onboarding/${cellvalues.row.id}`, {
              //         state: {
              //           fullname: cellvalues.row.seller.name,
              //         },
              //       })
              //     :
              //      navigate(`/onboarding/farmers/${cellvalues.row.seller.id}`, {
              //         state: {
              //           fullname: cellvalues.row.seller.name,
              //         },
              //       });
              //     handleEditDetails(cellvalues.row)

              // }}
              onClick={() => {
                if (
                  RoleAcessParams.includes("HCL") ||
                  RoleAcessParams.includes("UP_GOV")
                ) {
                  navigate(
                    `/farmerDetail/onboarding/${cellvalues.row.seller.id}`,
                    {
                      state: {
                        fullname: cellvalues.row.seller.name,
                      },
                    }
                  );
                } else {
                  // setEditModal(true);
                  // setEditDetails(cellvalues.row);
                  handleEditDetails(cellvalues.row);
                }
              }}
            />
          </>
        );
      },
    },
  ];

  const tableData = {
    rows: filteredData.length > 0 ? filteredData : trades,
    columns: columns,
    // paginationState: [pagination, setPagination],
    isLoading: loading,
    checkboxShowFalse: true,
  };
  const ReloadApplication = () => {
    setLoading(true);
    setTimeout(() => {
      handleApi();
      setLoading(false);
    }, 1500);
  };
  const downloadExcel = () => {
    setLoading(true);
    const headers = [
      "Commodity Name",
      "Farmer Number",
      "Phone Number",
      "State",
      "District",
      "Block",
      "Variety",
      "Quantity",
      "Unit",
      "Rate",
      "Status",
    ];

    const rows = trades?.map((user) => {
      const baseRow = {
        CommodityName: user.commodity.name || "",
        FarmerName: user.seller.name || "",
        Phone: user.seller.phone_number || "",
        State: handleLocation(user.seller.farm_location, "state"),
        District: handleLocation(user.seller.farm_location, "district"),
        Block: handleLocation(user.seller.farm_location, "block"),
        Variety: user.commodity.variety || "",
        Quantity: user.quantity || "",
        Unit: user.unit_of_quantity || "",
        Rate: user.quoted_price || "",
        Status: user.current_status || "",
      };

      return baseRow;
    });
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
    setLoading(false);
    XLSX.writeFile(workbook, "Commodity.xlsx");
  };
  const handleChange = (event, newValue) => {
    setSelectedLabel(event.target.value);
    let filteredDats =
      event.target.value === "All"
        ? tradeDataFiltered
        : tradeDataFiltered.filter(
            (item) => item.current_status === event.target.value
          );
    setTrades(filteredDats);
  };

  //   const handleSubmitDetails = (e) => {
  //     e.preventDefault();

  //     let payload = {
  //       current_status: editDetails.current_status,
  //       quoted_price: editDetails.quoted_price,
  //       quantity: editDetails.quantity,
  //       harvest_date: editDetails.harvest_date,
  //       unit_of_quantity: editDetails.unit_of_quantity,
  //     };
  //     disableSubmitBtn(true);
  //     const formdata = new FormData();
  // formdata.append("filename", "name");
  // formdata.append("file_type", "image");
  // formdata.append("media_category", "procurement");
  // formdata.append("media_type", "media");
  // formdata.append("files", fileInput.files[0], "/C:/Users/adlea/Downloads/background-img.jpg");
  // formdata.append("entity_id", "123456");
  //     uploadMedia (payload)
  //       .unwrap()
  //       .then((data) => {
  //         if (data.success) {

  //         } else {

  //         }
  //       });
  //     editTask({ tradeId: editDetails.id, payload: payload })
  //       .unwrap()
  //       .then((data) => {
  //         swal("Trade Updated Successfully", {
  //           buttons: false,
  //           icon: "success",
  //           title: "Updated Details",
  //           timer: 1500,
  //         });
  //         setEditModal(false);
  //         disableSubmitBtn(false);
  //         handleApi();
  //       })
  //       .catch((error) => {
  //         toast.error("Error while Updating Details");
  //         disableSubmitBtn(false);
  //         return;
  //       });
  //   };

  const handleSearch = (searchValue) => {
    if (!searchValue.trim()) {
      setFilteredData([]); // Reset filtered data when search is empty
      return;
    }

    const filteredResults = trades?.filter(
      (item) =>
        item.commodity.name.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.seller.name.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.seller.phone_number
          .toLowerCase()
          .includes(searchValue.toLowerCase())
    );

    setFilteredData(filteredResults);
  };

  return (
    <div>
      <Card className="transparent_card mt-2">
        <CardBody className="p-1 p-lg-3 ">
          {/* <Row className="mt-1 px-1">
            <Col
              xs="12"
              md="6"
              lg="8"
              className="d-flex align-items-center gap-3 flex-nowrap">
              <CustomSearchBar sendSearchFunction={handleSearch} />
              Select Status :
              <FormControl
                component="fieldset"
                className="d-flex align-items-center"
              >
                <RadioGroup
                  row
                  aria-label="business-type"
                  name="business-type"
                  value={selectedProduct}
                  onChange={handleChange}
                  className="d-flex gap-2 flex-nowrap"
                >
                  {["Procurement Done", "Negotiation Done", "All"].map(
                    (option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={
                          <Radio
                            sx={{
                              "&.Mui-checked": { color: "orange" },
                              "&:hover": {
                                backgroundColor: "rgba(255, 165, 0, 0.1)",
                              },
                              transform: "scale(0.8)",
                              width: 14,
                              height: 14,
                              marginRight: "10px",
                            }}
                          />
                        }
                        label={option}
                        style={{
                          color: selectedProduct === option ? "orange" : "gray",
                          fontWeight:
                            selectedProduct === option ? "bold" : "normal",
                          fontSize: "10px",
                        }}
                      />
                    )
                  )}
                </RadioGroup>
              </FormControl>
            </Col>
            <Col
              xs="12"
              md="6"
              lg="4"
              className="d-flex align-items-center justify-content-end ms-auto">
              <div className="mt-2">
                Total:
                <span className="text-success">
                  &nbsp;{trades ? trades.length : ""}
                </span>
              </div>
              <BootstrapButton
                id="AddLeads"
                className="buttonGreenDefaultColor mx-4"
                size="sm"
                onClick={downloadExcel}
              >
                Download &nbsp;
                <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
              </BootstrapButton>
              <Button
                className="bg-transparent text-black fs-6 reloadButton"
                size="sm"
                onClick={ReloadApplication}
                style={{ width: "10%", minWidth: "10%", marginLeft: "-10px" }}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </Button>
            </Col>
          </Row> */}

          <Row className="mt-2 px-2 align-items-center">
            <Col
              xs="12"
              md="6"
              lg="8"
              className="d-flex flex-wrap align-items-center gap-3"
            >
              <CustomSearchBar sendSearchFunction={handleSearch} />

              <div className="d-flex align-items-center">
                <span
                  className="me-2 fw-semibold"
                  style={{ fontSize: "13px", whiteSpace: "nowrap" }}
                >
                  Select Status:
                </span>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="business-type"
                    value={selectedProduct}
                    onChange={handleChange}
                    className="d-flex gap-3"
                  >
                    {["Procurement Done", "Negotiation Done", "All"].map(
                      (option) => (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={
                            <Radio
                              size="small"
                              sx={{
                                color: "gray",
                                "&.Mui-checked": {
                                  color: "orange",
                                },
                              }}
                            />
                          }
                          label={
                            <span
                              style={{
                                fontSize: "12px",
                                color:
                                  selectedProduct === option
                                    ? "orange"
                                    : "#555",
                                fontWeight:
                                  selectedProduct === option ? 600 : 400,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {option}
                            </span>
                          }
                          sx={{ margin: 0 }}
                        />
                      )
                    )}
                  </RadioGroup>
                </FormControl>
              </div>
            </Col>

            <Col
              xs="12"
              md="6"
              lg="4"
              className="d-flex align-items-center justify-content-end mt-2 mt-md-0 gap-3"
            >
              <div style={{ fontSize: "13px" }}>
                <strong>Total:</strong>
                <span className="text-success fw-semibold">
                  &nbsp;{trades?.length || 0}
                </span>
              </div>

              <BootstrapButton
                id="AddLeads"
                className="buttonGreenDefaultColor"
                size="sm"
                onClick={downloadExcel}
              >
                Download &nbsp;
                <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
              </BootstrapButton>

              <Button
                className="bg-transparent text-black fs-6 reloadButton"
                size="sm"
                onClick={ReloadApplication}
                style={{ width: "10%", minWidth: "10%" }}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </Button>
            </Col>
          </Row>
        </CardBody>
        {loading ? (
          <Skeleton count={10} />
        ) : (
          <div className="p-1 p-lg-3 " style={{ marginTop: "-20px" }}>
            <div>
              {trades?.length === 0 ? (
                <div
                  className="alert alert-warning d-flex align-items-center justify-content-center flex-column mt-4 mb-4 py-4 px-3 shadow-sm rounded"
                  style={{
                    fontSize: "14px",
                    backgroundColor: "#fff8e1",
                    color: "#795548",
                    border: "1px solid #ffe082",
                  }}
                >
                  <div style={{ fontSize: "20px", marginBottom: "6px" }}>
                    ⚠️
                  </div>
                  <div>No Data Found</div>
                </div>
              ) : (
                <DataGrid
                  rows={tableData.rows}
                  columns={tableData.columns}
                  isLoading={tableData.loading}
                  pagination
                  pageSizeOptions={[5, 10, 20]}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                />
              )}
            </div>
          </div>
        )}
      </Card>
      <Modal
        title="Buyers List"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        width={1000}
        footer={null}
        className="p-lg-2 p-0"
      >
        <BuyerListMandi tradeData={tradeData} setModalOpen={setModalOpen} />
      </Modal>
      <Modal
        title="Negotiate Details"
        open={negotiateModal}
        onCancel={() => {
          setnegotiateModal(false);
          setactiveNegotiation("ByFarmer");
        }}
        width={1000}
        footer={null}
        className="p-lg-2 p-0"
      >
        <FarmerAdminNegotiation
          tradeData={tradeData}
          setnegotiateModal={setnegotiateModal}
          setactiveNegotiation={setactiveNegotiation}
          activeNegotiation={activeNegotiation}
        />
      </Modal>
      <ModalBoot
        show={editDetailsModal}
        onHide={() => {
          setEditModal(false);
        }}
        size="xl"
      >
        <ModalBoot.Header closeButton>
          <ModalBoot.Title className="fw-bold">Update Details</ModalBoot.Title>
        </ModalBoot.Header>
        <ModalBoot.Body className="p-4">
          <EditMandiDetails
            isHCL={isHCL}
            setEditModal={setEditModal}
            handleApi={handleApi}
            setEditDetails={setEditDetails}
            editDetails={editDetails}
          />
        </ModalBoot.Body>
      </ModalBoot>
    </div>
  );
};
